<div class="registration-container">
  <div class="page-container" [class.mobile-actions-visible]="selectedProduct && !isCurrent(selectedProduct)">
    <div class="spinner-holder" *ngIf="!ready">
      <app-spinner></app-spinner>
    </div>

    <div *ngIf="ready">
      <ng-container *ngIf="scenario === 'no_membership'">
        <h1>Change Membership</h1>
        You do not yet have a membership. <a routerLink="/join">Click here to join</a>.<br/>
        Looking for your membership? Make sure you are signed into the correct account. 
      </ng-container>
      <ng-container *ngIf="scenario === 'inactive'">
        <h1>Change Membership</h1>
        Your membership has expired and cannot be changed. <a routerLink="/join">Click here to sign up for a new membership</a>.<br/>
        Looking for another membership? Make sure you are signed into the correct account. 
      </ng-container>
      <ng-container *ngIf="scenario === 'supported'">
        <header>
          <tyt-plus-tag></tyt-plus-tag>
          <div class="title">
            Change Membership Plan
          </div>
        </header>
    
        <div class="main">
          <div class="sidebar">
            <header>
              Select New Plan:
            </header>
            <ul class="option-list">
              <li 
                *ngFor="let product of availableMembershipProducts"
                [class.current]="isCurrent(product)"
                [class.selected]="selectedProduct?.id === product?.id"
                >
                <a 
                    routerLink="/membership/change" 
                    [queryParams]="{ product: product.id }"
                    attr.aria-label="{{isCurrent(product) ? 'Current Plan' : 'New Plan'}}: {{product.name}}"
                  >
                  <div class="name">{{product.name}}</div>
                  <div class="period">{{formatPeriod(product.period)}}</div>
                  <div class="price">{{product.price / 100 | currency: 'USD'}}</div>
                </a>
                <div class="mobile-details" *ngIf="selectedProduct?.id === product?.id">
                  <details>
                    <summary>
                      <div class="icon-container closed"><i class="fas fa-chevron-down"></i></div>
                      <div class="icon-container opened"><i class="fas fa-chevron-up"></i></div>

                      <ng-container *ngIf="isCurrent(selectedProduct)">
                        Show Current Plan Benefits
                      </ng-container>
                      <ng-container *ngIf="!isCurrent(selectedProduct)">
                        Show Plan Benefits
                      </ng-container>
                    </summary>
                    <div class="offer-benefits">
                      <div class="benefits" [innerHTML]="selectedProduct.description | trustHtml"></div>
                      <tyt-membership-features class="mini" [product]="selectedProduct"></tyt-membership-features>
                    </div>
                  </details>
                </div>
              </li>
            </ul>
          </div>
          <div class="detail">
            <ng-container *ngIf="!selectedProduct">
              Select a product to get started.
            </ng-container>
            <ng-container *ngIf="selectedProduct">
              <header>
                <ng-container *ngIf="isCurrent(selectedProduct)">
                  Your Current Plan:
                </ng-container>
                <ng-container *ngIf="!isCurrent(selectedProduct)">
                  New Plan:
                </ng-container>
              </header>
              <div class="plan-details">
                <div class="identity">
                  <div class="name">{{selectedProduct.name}}</div>
                  <div class="description offer-benefits" [innerHTML]="selectedProduct.description | trustHtml"></div>
                </div>
                <div class="benefits">
                  <tyt-membership-features
                    [product]="selectedProduct"
                    ></tyt-membership-features>
                </div>
              </div>

              <div class="current-plan" *ngIf="isCurrent(selectedProduct)">
                This is your current plan.
              </div>
              <div class="actions">
                <a *ngIf="!isCurrent(selectedProduct)" routerLink="/membership/change/products/{{selectedProduct?.id}}">Change My Benefits</a>
                <a class="secondary" routerLink="/settings/memberships">Keep My Current Membership Benefits</a>
              </div>

              <div class="billing" *ngIf="paymentSource">
                <label>
                  Billed to:
                </label>
                <div class="card">
                  {{paymentSource.brand}} **{{paymentSource.last4}} {{paymentSource.exp_month}}/{{paymentSource.exp_year}}
                </div>
                <a routerLink="/billing/update">Change Card</a>
              </div>

            </ng-container>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="scenario === 'google_play'">
        <h1>Change Membership</h1>
        <p>Your current membership was purchased through the Google Play Store and can’t be changed.  
          If you wish to change to a different membership level, you must first cancel your Google Play subscription billing, 
          then wait until the end of your pre-paid membership period plus 72 hours. At that point, you can go to tyt.com and 
          purchase your desired membership level via credit card without being double billed.<br/><br/>
          To cancel your current membership, sign in to your <a target="_blank" href="https://play.google.com/store/account/subscriptions">Google Play Store Account</a>, 
          click on My Subscriptions, and then click on TYT Plus from the list displayed under My Subscriptions.
        </p>
        <a routerLink="/account">Back to My Account</a>
      </ng-container>
      <ng-container *ngIf="scenario === 'iap_apple'">
        <h1>Change Membership</h1>
        <p>Your current membership was purchased through the iOS App Store and can't be changed.
          If you wish to change to a different membership level, you must first cancel your iTunes subscription billing, 
          then wait until the end of your pre-paid membership period plus 72 hours.  At that point, you can go to 
          tyt.com and purchase your desired membership level via credit card without being double billed.</p>
        <p>To cancel your current membership, sign in to your <a target="_blank" href="https://buy.itunes.apple.com/WebObjects/MZFinance.woa/wa/DirectAction/manageSubscriptions">iOS App Store Account</a>, click on Subscriptions, and then 
          click on TYT Plus from Active Subscriptions.</p>
        <a routerLink="/account">Back to My Account</a>
      </ng-container>
      <ng-container *ngIf="scenario === 'youtube'">
        <h1>Change Membership</h1>
        <p>Your current membership was purchased through YouTube and can't be changed from within TYT.com.
          To change or cancel your YouTube Channel Membership, visit the YouTube channel you subscribed to (The Young Turks,
          Damage Report, or other TYT associated YouTube channel) and click "See Perks".
        <a routerLink="/account">Back to My Account</a>
      </ng-container>
      <ng-container *ngIf="scenario === 'paypal_agreement' || scenario === 'paypal_classic'">
        <h1>Change Membership</h1>
        <p>Your current membership was purchased through Paypal. Unfortunately we are not accepting new memberships via 
          PayPal at this time. If you wish to change your membership plan you will need to switch to another method of
          payment.</p>
  
        <ol>
          <li>Log into your Paypal account at <a target="_blank" href="https://www.paypal.com">PayPal.com</a>, and 
              click Manage Pre-Approved Payments.</li>
          <li>Locate your TYT membership and use the Cancel option.</li>
          <li>Return to <a href="https://www.tyt.com">tyt.com</a> (or download one of our mobile apps from 
              <a target="_blank" href="https://tyt.com/app">here</a>) and purchase the membership you want to 
              switch to. You'll need to use another form of payment as PayPal is no longer supported.<br/>
              <strong>Important:</strong> If you receive an error indicating that you already have a membership or 
              are redirected from the purchase flow to your Membership Accounts page, you may need us to remove 
              the cancelled PayPal record to continue. Send us a note at 
              <a href="mailto:support@tytnetwork.com">support@tytnetwork.com</a> and we'll get it straightened out.
          </li>
        </ol>
  
        <p>Thanks for being a TYT member!</p>
  
        <a class="back" (click)="toPrevious()">Back to My Account</a>
      </ng-container>
    </div>
    <tyt-staging-note style="margin-top: 2em; display: block;">
      <strong>Test Scenarios</strong>
      <div>
        <ng-container *ngFor="let possibleScenario of scenarios">
          <a href="javascript:;" (click)="scenario = possibleScenario.id">{{possibleScenario.label}}</a> |
        </ng-container>
      </div>
    </tyt-staging-note>
  </div>
</div>

<div class="mobile actions" #mobileActions [class.visible]="selectedProduct && !isCurrent(selectedProduct)">
  <a *ngIf="!isCurrent(selectedProduct)" routerLink="/membership/change/products/{{selectedProduct?.id}}">Change My Benefits</a>
  <a class="secondary" routerLink="/settings/memberships">Keep My Current Membership Benefits</a>
</div>